import * as FileSaver from "file-saver"
import React from 'react'
import ReactPaginate from 'react-paginate'
import * as XLSX from "xlsx"
import Order from '../../components/OrderForEvacuation/OrderForEvacuation'
import Button from '../../components/UI/Button/Button'
import Input from '../../components/UI/Input/Input'
import Modal from '../../components/UI/Modal/Modal'
import Search from '../../components/UI/Search/Search'
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'
import './OrdersForEvacuation.css'
import PlayArrow from '@material-ui/icons/PlayArrow'
import Pause from '@material-ui/icons/Pause'

const OrdersForEvacuation = (props) => {

    const [orders, setOrders] = React.useState([])
    const [offset, setOffset] = React.useState('1')
    const [perPage, setPerPage] = React.useState('3')
    const [pageCount, setPageCount] = React.useState('0')
    const [loading, setLoading] = React.useState(false)
    const [getParcel, setGetParcel] = React.useState(false)
    const [autoPlay, setAutoPlay] = React.useState(false)
    const [searchParams, setSearchParams] = React.useState({
        evacuation: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'مهلت(دقیقه)'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: '180',
        },
    })
    const [modalContent, setModalContent] = React.useState('')
    const childRef = React.useRef();

    const MINUTE_MS = 5 * 60 * 1000;
    React.useEffect(() => {
        const interval = setInterval(() => {
            if (autoPlay) {
                var raw = JSON.stringify({
                    "filter": {
                        evacuation: searchParams.evacuation.value,
                    },
                    "pl": 3,
                    "pn": 1,
                    "version": "mtpx001"
                })

                var url = 'management/api/v1/orders/getOrdersForEvacuation'
                FetchData(raw, url).then(response => response.json())
                    .then(result => {
                        if (result.status == 0) {
                            setOrders(result.orders)
                            setPageCount(result.count / parseInt(perPage))
                        }
                    })
                    .catch(error => console.log(error))
            }
        }, MINUTE_MS);
        return () => clearInterval(interval);
    }, [autoPlay]);
    React.useEffect(() => {
        setOffset(1)
        setPerPage(3)
        setPageCount(0)
        const search = searchParams
        for (let key in search) {
            search[key].value = '180'
        }
        setSearchParams(search)

        var raw = JSON.stringify({
            "filter": {
                evacuation: searchParams.evacuation.value,
            },
            "pl": 3,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/orders/getOrdersForEvacuation'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setOrders(result.orders)
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => console.log(error))
        var raw = JSON.stringify({
            "kiosk": {
            },
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
    }, [])

    const handlePageClick = (e) => {
        setOffset(e.selected + 1)
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                evacuation: searchParams.evacuation.value,
            },
            "pl": perPage,
            "pn": e.selected + 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getOrdersForEvacuation'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setOrders(result.orders)
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => setLoading(false))
    }

    const search = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                evacuation: searchParams.evacuation.value,
            },
            "pl": perPage,
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getOrdersForEvacuation'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    setOrders(result.orders)
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => setLoading(false))
    }

    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = '180'
        }
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                evacuation: '180',
            },
            "pl": perPage,
            "pn": 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/orders/getOrdersForEvacuation'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setOrders(result.orders)
                    setPageCount(result.count / parseInt(perPage))
                }
            })
            .catch(error => console.log(error))
    }

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const emptyParcels = (event, id) => {
        setGetParcel(false)
        const ords = orders
        const ord = ords.filter(o => o.id == id)[0]
        ord.parcels = null
        setOrders(ords)
        setTimeout(() => {
            setGetParcel(true)
        }, 500)
    }

    const getParcels = (event, id) => {
        setGetParcel(false)
        var info = {
            "order": {
                "id": id,
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/orders/getOrderInfo'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                const ord = orders
                const order = ord.filter(o => o.id == id)[0]
                order.parcels = result.order.parcels
                setOrders(ord)
                setGetParcel(true)
            })
            .catch(error => console.log(error))
    }

    let orderList = []
    if (orders !== null) {
        orderList = getParcel ? orders.map(o => <Order updateGrid={search} showParcels={getParcel} emptyParcels={emptyParcels} getParcels={getParcels} refreshOrders={search} order={o} />) : orders.map(o => <Order getParcels={getParcels} emptyParcels={emptyParcels} refreshOrders={search} order={o} />)
    }
    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }

    const afterCloseModal = (event) => {
    }

    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                evacuation: searchParams.evacuation.value,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getOrdersForEvacuation'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrder = []
                    let count = 0
                    const order = result.orders.map(o => {

                        count++
                        exportOrder.push({
                            'ردیف': count,
                            'شماره سفارش': o.orderNumber,
                            'شناسه سفارش دهنده': o.courierTrackNumber,
                            'تاریخ ثبت': o.registerDate,
                            'نام ثبت کننده': o.unit != null ? o.unit.unitName : '',
                            "تاریخ شروع": o.startDate,
                            "ساعت شروع": o.startTime,
                            "تاریخ پایان": o.endDate,
                            "ساعت پایان": o.endTime,
                            "هزینه باکس": o.lockerAmount,
                            "مالیات": o.taxAmount,
                            "هزینه نهایی": o.finalAmount,
                            'دلیل کنسلی': o.cancelReason
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrder);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'Orders' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr">
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2 ord-small-btns">
                <Button btnType="search-btn" clicked={search}>
                    <span className="tab-color">
                        جستجو
                    </span>
                </Button>
            </div>
            <div className="col-2 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={() => { search(); setAutoPlay(!autoPlay) }}>
                    <span className="tab-color" style={{ cursor: 'pointer' }}>
                        {
                            autoPlay ?
                                < Pause />
                                :
                                <PlayArrow />
                        }
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-orders">
            <Search class="orders-search" form={form} />
            <div className="row justify-content-center">
                {orderList}
            </div>
            {orders != null && orders.length != 0 ?
                <div className="row justify-content-center">
                    <ReactPaginate
                        previousLabel={"→قبلی"}
                        nextLabel={"بعدی←"}
                        forcePage={offset >= 0 ? offset - 1 : offset}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div>
                : ''}
            <Modal
                content={modalContent}
                ref={childRef}
                closePermission="true"
                closeModal={(event) => afterCloseModal(event)}
            />
        </div>
    )
}
export default OrdersForEvacuation